module.exports = __webpack_public_path__ + "media/application/images/svgs/codepen-be9454c593f902a49f3b5357412582e5.svg";